import React from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import { isAuthenticated } from "../services/accountService";
import { divisionAccesses, pages } from "../constants";

const PrivateRoute = ({
  children,
  accessNeeded,
  allowedDivisionAccesses = [divisionAccesses.network],
  customersCanAccess,
  customerOnly,
  redirectURL = pages.loginPage.url,
  statusCheck,
  ...rest
}) => {
  const { pathname } = useLocation();
  return (
    <Route
      {...rest}
      render={() =>
        isAuthenticated(
          accessNeeded,
          customersCanAccess,
          pathname,
          statusCheck,
          customerOnly,
          allowedDivisionAccesses
        ) ? (
          children
        ) : (
          <Redirect to={redirectURL} />
        )
      }
    />
  );
};

export default PrivateRoute;
